import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { contentSubmissionRepository } from '../repositories/contentSubmission.repository';
import { contentKeys } from '../services/content.keys';
import type { ContentSubmission } from '../types/content.types';

export const useInfluencerPosts = (campaignInfluencerId: string | null) => {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id || '';

  return useQuery({
    queryKey: contentKeys.posts(orgId, campaignInfluencerId),
    queryFn: async (): Promise<ContentSubmission[]> => {
      if (!campaignInfluencerId || !orgId) return [];
      return contentSubmissionRepository.getPostsByCampaignInfluencerId(orgId, campaignInfluencerId);
    },
    enabled: !!campaignInfluencerId && !!orgId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
